export default function MindFrame() {
  return (
    <section
      data-testid="mind-frame-section"
      className="relative px-6 lg:px-10 py-28 lg:py-40 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1755376063044-193ca29d6730?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxzbW9vdGglMjBzdG9uZSUyMG1pbmltYWwlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3ODE4NjkxNnww&ixlib=rb-4.1.0&q=85')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(249,248,245,0.6) 0%, rgba(249,248,245,0.85) 60%, #F8FAFC 100%)",
        }}
      />

      <div className="relative max-w-3xl mx-auto text-center fade-up">
        <p className="text-sm tracking-[0.18em] uppercase font-semibold text-[#475569]">
          The brain you actually have today
        </p>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium leading-[1.05]">
          Designed for the brain you actually have today.
        </h2>

        <div className="mt-10 space-y-3 text-lg text-[#0F172A]">
          <p>Some days you need a plan.</p>
          <p>Some days you need a smaller task.</p>
          <p>Some days you need the page to get quieter.</p>
          <p>Some days you need permission to drop something.</p>
        </div>

        <div className="mt-10 inline-block">
          <p className="font-display text-xl sm:text-2xl text-[#0F172A] max-w-xl">
            Mindrail adapts around those realities. It does not ask you to
            become perfectly consistent —{" "}
            <span className="text-[#22C55E]">
              it helps you recover when you are not.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
}
